import { useState } from "react";
import { NativeSelect } from "@/components/common";
import { CompareTable } from "@/components/RevisionEditor";
import { fmtDateTime, num } from "@/lib/format";

export function VersionHistory({ versions }) {
  const [a, setA] = useState(Math.max(0, versions.length - 2));
  const [b, setB] = useState(versions.length - 1);
  if (!versions.length) return <p className="text-sm text-slate-500">Riwayat versi tersedia setelah invoice disahkan.</p>;
  return (
    <div className="space-y-3" data-testid="version-history">
      <div className="xl-wrap">
        <table className="xl">
          <thead><tr><th>Versi</th><th>Waktu</th><th>Diedit</th><th>Diajukan</th><th>Disetujui</th><th className="text-right">Total Qty</th><th className="text-right">Total</th><th>Alasan</th></tr></thead>
          <tbody>
            {versions.map((v, i) => (
              <tr key={v.rev} className={i === versions.length - 1 ? "bg-emerald-50" : ""} data-testid={`version-row-${i}`}>
                <td className="font-semibold">{v.label}{i === versions.length - 1 ? " (berlaku)" : ""}</td><td className="text-xs">{fmtDateTime(v.at)}</td>
                <td className="text-xs">{v.edited_by || "-"}</td><td className="text-xs">{v.requested_by || "-"}</td><td className="text-xs">{v.approved_by || "-"}</td>
                <td className="num">{num(v.total_qty)}</td><td className="num">{num(v.total)}</td><td className="text-xs max-w-[200px] truncate" title={v.reason}>{v.reason || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {versions.length > 1 && (
        <>
          <div className="flex flex-wrap items-center gap-2 text-sm">
            <span className="font-semibold">Bandingkan</span>
            <NativeSelect value={a} onChange={(e) => setA(Number(e.target.value))} data-testid="compare-a">{versions.map((v, i) => <option key={v.rev} value={i}>{v.label}</option>)}</NativeSelect>
            <span>dengan</span>
            <NativeSelect value={b} onChange={(e) => setB(Number(e.target.value))} data-testid="compare-b">{versions.map((v, i) => <option key={v.rev} value={i}>{v.label}</option>)}</NativeSelect>
          </div>
          <CompareTable a={versions[a]} b={versions[b]} />
        </>
      )}
    </div>
  );
}
